import React, { useEffect } from 'react';

import * as styles from './styles.css';
import ErrorBoundary from '../../../Components/Context/ErrorBoundary';
import Box, { BoxProps } from '../../../Components/UI/Box';
import ErrorFallback from '../../../Components/UI/ErrorFallback';

interface MainBodyProps extends BoxProps {
  language?: string | null;
  children: React.ReactNode;
}

const MainBody: React.FC<MainBodyProps> = ({ language, children, ...rest }) => {
  useEffect(() => {
    if (!language) {
      return;
    }

    document.documentElement.lang = language;
  }, [language]);

  return (
    <ErrorBoundary fallback={<ErrorFallback language={language} renderNavigation={false} />}>
      <Box element="div" display="flex" flexDirection="column" flex={1} className={styles['main']} {...rest}>
        <Box display="flex" flex={1}>
          {children}
        </Box>
      </Box>
    </ErrorBoundary>
  );
};

export default MainBody;
